import styled from 'styled-components';

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: auto;
  padding: 24px 16px;
  background: #f3f3f3;
  color: #848484;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;

export const Copyright = styled.div``;

export const HelpEmail = styled.a`
  color: inherit;
  text-decoration: underline;
`;

export const Links = styled.div`
  display: flex;
  justify-content: center;
  gap: 26px;
`;

export const LinkItem = styled.button`
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  color: #323232;
  text-decoration: underline;
  cursor: pointer;
`;
